import { render, staticRenderFns } from "./operatePlatformCourses.vue?vue&type=template&id=5013242c&scoped=true"
import script from "./operatePlatformCourses.vue?vue&type=script&lang=js"
export * from "./operatePlatformCourses.vue?vue&type=script&lang=js"
import style0 from "./operatePlatformCourses.vue?vue&type=style&index=0&id=5013242c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013242c",
  null
  
)

export default component.exports